// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var NumberSequenceController = function ($rootScope, $scope, $routeParams, $location, NumberSequence, gettextCatalog, gettext) {
    $scope.tooltipsArray = Object.freeze({
        "IsUsedForContractExternalId": "The sequence will be applied for all new contracts and will be assigned to the external contract id field.",
        "GenerateContractExternalIdOnOrderCreation": "The sequence will be applied for all new created orders and will be assigned to the external contract id field."
    });
    
    function getShortCode(value, shortcode) {
        return (value && value.indexOf(shortcode) > -1);
    }

    if ($routeParams.sequenceId) {
        $scope.numberSequence = NumberSequence.get({ sequenceId: $routeParams.sequenceId }, function () { });
    } else {
        $scope.numberSequence = new NumberSequence();
    }

    NumberSequence.query({ }).$promise.then(function (sequences) {
        $scope.sequences = sequences;
        
        $scope.canFillNewContractsExternalId = function () {
            return $scope.sequences.every(function (sequence) {
                return !sequence.IsUsedForContractExternalId || sequence.SequenceName === $scope.numberSequence.SequenceName; 
            });
        };
    });

    $scope.clearGenerateContractExternalIdOnOrderCreationIfRequired = function () {
        if (!$scope.numberSequence.IsUsedForContractExternalId) {
            $scope.numberSequence.GenerateContractExternalIdOnOrderCreation = false;
        }
    };

    $scope.shouldBeDisableGenerateContractExternalIdOnOrderCreation = function () {
        return !$scope.numberSequence.IsUsedForContractExternalId;        
    };
    
    $scope.$watch("numberSequence.CounterType",
        function () {
            if ($scope.numberSequence.CounterType === 'Contract') {
                $scope.numberSequence.Counter = '';
            }
        });
    $scope.save = function () {
        if (!$rootScope.isValid($scope.form)) {
            return;
        }

        var prefix = $scope.numberSequence.Prefix;
        var suffix = $scope.numberSequence.Suffix;

        if ($scope.numberSequence.CounterType === 'Yearly') {
            var shortcodeYear = getShortCode(prefix, '[year]') || getShortCode(suffix, '[year]');
            if (!shortcodeYear) {
                $scope.notify("error", gettextCatalog.getString(gettext("Make sure you use [year] in the prefix or suffix to avoid duplicates when using the yearly mode.")));
                return false;
            }
        }

        if ($scope.numberSequence.CounterType === 'Monthly') {
            var shortcodeYear = getShortCode(prefix, '[year]') || getShortCode(suffix, '[year]');
            var shortcodeMonth = getShortCode(prefix, '[month]') || getShortCode(suffix, '[month]');
            if (!(shortcodeYear && shortcodeMonth)) {
                $scope.notify("error", gettextCatalog.getString(gettext(" Make sure you use [year],[month] in the prefix or suffix to avoid duplicates when using the yearly/monthly mode.")));
                return false;
            }
        }

        if ($scope.numberSequence.CounterType === 'Contract') {
            var shortcode = getShortCode(prefix, '[refcode]') || getShortCode(suffix, '[refcode]');
            if (!(shortcode)) {
                $scope.notify("error", gettextCatalog.getString(gettext(" Make sure you use [refcode] in the prefix or suffix to avoid conflicting sequence numbers when using the contract mode.")));
                return false;
            }
        }

        if ($routeParams.sequenceId) {
            $scope.numberSequence.$update({ sequenceId: $routeParams.sequenceId }, function () { $location.path('/settings/sequences'); });
        } else {
            if ($scope.numberSequence.SequenceType === 'Contract') {
                $scope.numberSequence.CounterType = 'Global';
            }
            if ($scope.numberSequence.SequenceType === 'Document') {
                $scope.numberSequence.IsUsedForContractExternalId = undefined;
            }
            
            $scope.numberSequence.$save({}, function () { $location.path('/settings/sequences'); });
        }
    };
};
NumberSequenceController.$inject = ['$rootScope', '$scope', '$routeParams', '$location', 'NumberSequence', 'gettextCatalog', 'gettext'];
